import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Col,
  Form,
  FormControl,
  FormLabel,
  FormSelect,
  ListGroup,
  Row,
} from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { Button, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { BiPlusCircle } from "react-icons/bi";
import { BiMinusCircle } from "react-icons/bi";
import { GPU_BRAND, GPU_CHIPSET, DEFAULT_PRODUCT_DESCRIPTION } from "../helper/constant";
import "./NewProduct.css";
import ExportApi from "../api/ExportApi";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Select from "react-select";
import GallerySvg from "../assets/svg/gallerySvg";
import { useAuthUser } from "../customHooks/useAuthUser";
import initialLoader from "../images/loader/loaderrrr.gif"
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import 'ckeditor5/ckeditor5.css';
// import 'ckeditor5-premium-features/ckeditor5-premium-features.css';


const NewProduct = () => {
  const loggedInUser = useAuthUser()
  const dragItem = useRef();
  const dragOverItem = useRef();
  const navigate = useNavigate();
  const [inputList, setInputList] = useState([""]);
  const [alreadyExist, setAlreadyExist] = useState({
    upc: [],
    sku: [], // mpn
    model: []
  })
  const [newseries, setNewseries] = useState();
  const [newProduct, setNewProduct] = useState({
    category: "63ff36fb23ad0386e761641f",
    chipset: "",
    brand: "",
    series: "",
    model: "",
    sku: "",
    upc: "",
    seoTitle: "",
    videos: "",
    new_retail_market_price: "",
    new_retail_price: "",
    new_retail_website_price: "",
    new_second_hand_market_price: "",
    new_second_hand_house_ask: "",
    used_market_price: "",
    used_house_ask: "",
    description: DEFAULT_PRODUCT_DESCRIPTION,
    type: [],
    admin: loggedInUser?.id,
    image: [],
    metaDescription: "",
    market_price_new_update_date: "",
    market_price_second_update_date: "",
    market_price_used_update_date: "", 
    key_specifications : ""
  })
  const [loader, setLoader] = useState({
    initialLoad: true,
    saveButtonLoading: false
  })

  const fetchIntialData = async () => {
    setLoader((prev) => ({ ...prev, initialLoad: true }));

    try {
      const [skuResp, seriesResp] = await Promise.all([
        ExportApi.GetSkuData(),
        ExportApi.getallseries()
      ]);

      // Process SKU data
      let data = skuResp.data.data;
      const existingModels = data.model.map((word) => word.toLowerCase());
      const existingSkus = data.sku.map((word) => word.toLowerCase());
      const existingUpcs = data.upc.map((word) => word.toLowerCase());
      setAlreadyExist({
        upc: existingUpcs,
        model: existingModels,
        sku: existingSkus
      });

      // Process series data
      setNewseries(seriesResp?.data);

    } catch (err) {
      setLoader((prev) => ({ ...prev, initialLoad: false }));
      console.log(err);
    } finally {
      // Only set false once both are finished
      setLoader((prev) => ({ ...prev, initialLoad: false }));
    }
  }

  useEffect(() => {
    fetchIntialData();
  }, [loggedInUser]);

  const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
    if (rejectedFiles?.length > 0) {
      if (rejectedFiles[0]?.errors[0]?.code == "file-too-large") {
        alert("Please upload an image file with a maximum size of 1MB.");
      } else if (rejectedFiles[0]?.errors[0]?.code == "file-invalid-type") {
        alert("Please upload an image file with jpeg,png and webp format.");
      }
    } else {
      // Process accepted files
      setNewProduct((prev) => ({
        ...prev,
        image: [
          ...(prev.image || []), // keep existing images
          ...acceptedFiles.map((file) =>
            Object.assign(file, { preview: URL.createObjectURL(file) })
          ),
        ],
      }));
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "image/jpeg": [],
      "image/png": [],
      "image/webp": [],
    },
    maxSize: 1024 * 1024,
  });

  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    var list = [...inputList];
    inputList.splice(index, 1);
    setInputList([...inputList]);
  };

  // handle click event of the Add button
  const handleAddClick = () => {
    setInputList([...inputList, ""]);
  };

  //Start for the Product Type
  const handleProductType = (e) => {
    const value = e.target.value; // value of the checkbox
    const checked = e.target.checked;

    setNewProduct((prev) => {
      let newType = [...(prev.type || [])]; // make a copy of existing array

      if (checked) {
        // push the value if checked and not already present
        if (!newType.includes(value)) newType.push(value);
      } else {
        // remove the value if unchecked
        newType = newType.filter((item) => item !== value);
      }

      return {
        ...prev,
        type: newType,
      };
    });

  };

  //Click on the Cancel Button
  const handleemptyProduct = () => {
    let confirm = window.confirm("Are You Want to Sure to cancel ");
    if (confirm) {
      navigate("/productlist");
    }
  };

  // to delete the Single image on the preview
  const handledeletesingleimage = (name) => {
    const result = newProduct?.image?.filter((file) => file.path !== name);
    setNewProduct((prev) => ({
      ...prev,
      image: result
    }))
  };

  const dragStart = (e, position) => {
    dragItem.current = position;
  };

  const dragEnter = (e, position) => {
    dragOverItem.current = position;
  };

  //remove all images click on remove all
  const handleremoveallimages = () => {
    setNewProduct((prev) => (
      {
        ...prev,
        image: []
      }
    ))
  };

  const drop = (e) => {
    const copyListItems = [...newProduct.image];
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    setNewProduct((prev) => ({
      ...prev,
      image: copyListItems
    }));
  };

  const handleInputChange = (field, value) => {
    const today = new Date();
    const formattedDate = moment(today).format("l");
    setNewProduct((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (field === "new_retail_market_price") {
      setNewProduct((prev) => ({
        ...prev,
        market_price_new_update_date: formattedDate,
      }));
    }
    else if (field === "new_second_hand_market_price") {
      setNewProduct((prev) => ({
        ...prev,
        market_price_second_update_date: formattedDate,
      }));
    }
    else if (field === "used_market_price") {
      setNewProduct((prev) => ({
        ...prev,
        market_price_used_update_date: formattedDate,
      }));
    }
  };

  //  validate all the fields
  const validateProduct = (product) => {

    // Testing the unique values
    if (product?.model?.trim() !== "" && alreadyExist?.model?.includes(product?.model?.toLowerCase())) {
      return `Model already exist`
    }
    if (product?.upc?.trim() !== "" && alreadyExist?.upc?.includes(product?.upc?.toLowerCase())) {
      return `UPC already exist`
    }
    if (product?.sku?.trim() !== "" && alreadyExist?.sku?.includes(product?.sku?.toLowerCase())) {
      return `MPN already exist`
    }

    // Fields we want to skip validation for
    const skipValidation = [
      "seoTitle",
      "videos",
      "metaDescription",
      "admin",
      "market_price_new_update_date",
      "market_price_used_update_date",
      "market_price_second_update_date",
      "New Retail Market Price",
      "New Retail Price",
      "New Retail Website Price",
      "New Second Hand Market Price",
      "New Second Hand House Ask",
      "Used Market Price",
      "Used House Ask", 
      "key_specifications"
    ];

    // Map for user-friendly labels
    const fieldLabels = {
      sku: "MPN",
      upc: "UPC",
      brand: "Brand",
      series: "Series",
      model: "Model",
      chipset: "Chipset",
      category: "Category",
      type: "Product type",
      image: "Image"
    };

    // Step 1: Validate general fields
    for (const [key, value] of Object.entries(product)) {
      if (skipValidation.includes(key)) continue;

      // Skip price-related fields (handled conditionally by type)
      if (
        [
          "new_retail_market_price",
          "new_retail_price",
          "new_retail_website_price",
          "new_second_hand_market_price",
          "new_second_hand_house_ask",
          "used_market_price",
          "used_house_ask"
        ].includes(key)
      ) {
        continue;
      }

      // Skip individual checks for upc & sku here (we’ll handle them below together)
      if (key === "upc" || key === "sku") continue;

      if (Array.isArray(value) && value.length === 0) {
        return `${fieldLabels[key] || key} is required`;
      }

      if (typeof value === "string" && value.trim() === "") {
    return `${fieldLabels[key] || key} is required`;
  }
}

    // Step 2: Ensure either UPC or MPN exists
    const hasUPC = product?.upc?.trim() !== "";
    const hasMPN = product?.sku?.trim() !== "";

    if (!hasUPC && !hasMPN) {
      return "Either UPC or MPN is required";
    }
    // Step 2: Validate type first
    if (!product.type || product.type.length === 0) {
      return `${fieldLabels["type"]} is required`;
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {

      const errorMessage = validateProduct(newProduct);
      if (errorMessage) {
        toast.error(errorMessage);
        return;
      }

      const productName = `${newProduct.brand} ${newProduct.series} ${newProduct.model}`.trim();
      const slug = productName.replace(/\s+/g, "-").toLowerCase();

      const formData = new FormData();
      Object.keys(newProduct).forEach((key) => {
        if (key === "image") {
          newProduct[key].forEach((file) => formData.append("image", file));
        } else {
          formData.append(key, newProduct[key]);
        }
      });

      formData.set("productname", productName); // DO NOT CHANGE VAR NAME
      formData.set("slug", slug);

      setLoader((prev) => (
        {
          ...prev,
          saveButtonLoading: true
        }
      ));
      ExportApi.Createproduct(formData)
        .then((resp) => {
          if (resp.data.status == true) {
            setLoader((prev) => (
              {
                ...prev,
                saveButtonLoading: false
              }
            ));
            toast.success("Product Added Successfully");
            navigate("/productlist");
          } else {
            toast.error("Error");
            setLoader((prev) => (
              {
                ...prev,
                saveButtonLoading: false
              }
            ));
          }
        })
        .catch((err) => console.log(err));
    } catch (error) {
      toast.error(error);
    }
  };


  return (
    <>
      {
        loader?.initialLoad ? (
          <div className="d-flex justify-content-center align-items-center py-5">
            <img src={initialLoader} alt="Loading..." style={{ height: "80px" }} />
          </div>
        )
          :
          (
            <div className="mt-5 make-index">
              <ToastContainer />
              <h2 className="mb-5 fw-bold">Add New Product</h2>
              <Row>
                <Col lg={12}>
                  <div className="basicinformation">
                    <h4 className="fw-bold">Basic Information</h4>
                    <p className="text-muted fw-bold">
                      Section to config basic product information
                    </p>
                    <Form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <FormLabel name="category" className="fw-bold fs-6">
                          Category
                        </FormLabel>
                        <FormSelect
                          id="select1"
                          className=""
                          onChange={(e) => handleInputChange("category", e.value)}
                          value={newProduct?.category}
                          autocomplete="off"

                        >
                          <option value="63ff36fb23ad0386e761641f">
                            Graphics Cards
                          </option>
                        </FormSelect>
                      </div>

                      <div className="mb-3">
                        <FormLabel className="fw-bold fs-6">Chipset</FormLabel>
                        <Select
                          options={GPU_CHIPSET}
                          onChange={(e) => handleInputChange("chipset", e.value)}
                          placeholder="i.e. AMD or Nvidia"
                          autocomplete="off"

                        />
                      </div>

                      <div className="mb-3">
                        <FormLabel className="fw-bold fs-6">Brand</FormLabel>
                        <Select
                          options={GPU_BRAND}
                          onChange={(e) => handleInputChange("brand", e.value)}
                          placeholder="i.e. MSI,PNY,Zotac etc..."
                          autocomplete="off"

                        />
                      </div>
                      <div className="mb-3">
                        <FormLabel className="fw-bold fs-6">Series</FormLabel>

                        {newseries ? (
                          <Select
                            options={newseries?.map((item) => ({
                              label: item.label,
                              value: item.value,
                            }))}
                            onChange={(e) => handleInputChange("series", e.value)}
                            placeholder="i.e. RTX3080TI, RTX 4090, etc..."
                            autoComplete="off"

                          />
                        ) : (
                          <p>Loading...</p>
                        )}
                      </div>

                      <div className="mb-3">
                        <FormLabel className="fw-bold fs-6">Model</FormLabel>
                        <FormControl
                          name="model"
                          className=""
                          onChange={(e) => handleInputChange("model", e.target.value)}
                          placeholder="i.e. Gaming X,Gaming X Trio etc.. "
                          autocomplete="off"

                        />
                        {alreadyExist?.model?.includes(
                          newProduct?.model.toLowerCase()
                        ) && (
                            <span className="text-danger">Model Already Exist</span>
                          )}
                      </div>

                      <div className="mb-3">
                        <FormLabel className="fw-bold fs-6">MPN:</FormLabel>
                        <FormControl
                          className=""
                          name="sku"
                          onChange={(e) => handleInputChange("sku", e.target.value)}
                          handle
                          autocomplete="off"
                          placeholder="MPN Unique Per product"
                        />
                        {alreadyExist?.sku.includes(
                          newProduct.sku.trim().toLowerCase()
                        ) &&
                          newProduct.sku.trim() !== "" && (
                            <span className="text-danger">MPN Already Exist</span>
                          )}
                      </div>
                      <div className="mb-3">
                        <FormLabel className="fw-bold fs-6">UPC:</FormLabel>
                        <FormControl
                          className=""
                          name="upc"
                          onChange={(e) => handleInputChange("upc", e.target.value)}
                          autocomplete="off"
                          placeholder="UPC Unique Per product"
                        />
                        {alreadyExist?.upc?.includes(
                          newProduct.upc.trim().toLowerCase()
                        ) &&
                          newProduct.upc.trim() !== "" && (
                            <span className="text-danger">UPC Already Exist</span>
                          )}
                      </div>

                      <div className="mb-3">
                        <FormLabel className="fw-bold fs-6">
                          Product Videos
                        </FormLabel>
                        <Form className="">
                          {inputList.map((x, i) => {
                            if (true) {
                              return (
                                <div className="d-flex mb-3 justify-content-between">
                                  <FormControl
                                    name={`embeddedVideoLink${i + 1}`}
                                    placeholder="Embedded Video Link"
                                    value={x}
                                    autocomplete="off"
                                    style={{}}
                                    onChange={(e) => handleInputChange(e, i)}
                                  />

                                  <button
                                    type="button"
                                    className="butt bg-none border-0"
                                    onClick={handleAddClick}
                                  >
                                    <BiPlusCircle style={{ fontSize: "30px" }} />
                                  </button>

                                  <button
                                    type="button"
                                    className="bg-none border-0 ms-2"
                                    onClick={() => handleRemoveClick(i)}
                                  >
                                    <BiMinusCircle
                                      style={{
                                        fontSize: "30px",
                                      }}
                                    />
                                  </button>
                                </div>
                              );
                            }
                          })}
                        </Form>
                      </div>

                      <div className="mb-3">
                        <h4 className="fw-bold">Gallery Image</h4>
                        <p className="text-muted fw-bold">
                          Add or change image for the Gallery
                        </p>

                        <div {...getRootProps()}>
                          <div className="d-flex justify-content-center flex-column align-items-center border px-3 py-5">
                            <input {...getInputProps()} />
                            <span className="">Support : Jpeg,Png,webp</span>
                            <span className="">Maximum image size supported: 1 MB</span>
                            <p>
                              <GallerySvg />
                              Drag and drop your images here.
                            </p>
                          </div>
                        </div>
                        {newProduct?.image?.length > 0 && (
                          <Button
                            className="remove_all_images mt-3"
                            variant="contained"
                            onClick={() => handleremoveallimages()}
                          >
                            Remove All
                          </Button>
                        )}
                        <div
                          className={`Whole_image_box mt-2 ${newProduct?.image?.length > 4 ? "extra-images" : ""}`}
                          style={{ display: "flex", marginTop: "20px" }}
                        >
                          {newProduct?.image?.map((file, index) => (
                            <div className="parent_div" key={index}>
                              <div
                                className="image_div"
                                draggable
                                onDragStart={(e) => dragStart(e, index)}
                                onDragEnter={(e) => dragEnter(e, index)}
                                onDragEnd={drop}
                              >
                                <img
                                  className="show_multi_images"
                                  src={file.preview}
                                  alt={file.name}
                                  height="200px"
                                  width="100%"
                                />
                              </div>
                              <div className="icon_div">
                                <IconButton color="error" onClick={() => handledeletesingleimage(file.path)}>
                                  <DeleteIcon />
                                </IconButton>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="protyppri">
                        <h4 className="mb-3 fw-bold">Product Type and Price</h4>
                        <div className="marretweb border rounded bg-custom-light p-5">
                          <div className="product-type">
                            <div className="new-retail">
                              <h5>New-Retail</h5>
                              <input
                                type="checkbox"
                                id="checkboxx"
                                name="checkbox"
                                value="1"
                                onClick={handleProductType}
                              />
                            </div>
                            <div className="prices">
                              <div className="market-price">
                                <h5 className=" mb-3">Market Price</h5>
                                <div>
                                  <FormControl
                                    name="new_retail_market_price"
                                    // onChange={(e) => handleMarketPrice(e, 0)}
                                    onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                                    placeholder="Comp Price"
                                    type="number"
                                    inputMode="numeric"
                                    min="0"
                                    step="any"

                                  />
                                  <p>
                                    Date:
                                    {newProduct?.market_price_new_update_date?.trim() !== "" ? newProduct?.market_price_new_update_date : ""}
                                  </p>

                                </div>
                              </div>
                              <div className="Retail-price">
                                <h5 className=" mb-3">Retail Price</h5>
                                <div>
                                  <FormControl
                                    name="new_retail_price"
                                    onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                                    placeholder="MSRP"
                                    type="number"
                                    inputMode="numeric"
                                    min="0"
                                    step="any"
                                  />
                                </div>
                              </div>
                              <div className="website-price">
                                <h5 className=" mb-3">Website Price</h5>
                                <div>
                                  <FormControl
                                    name="new_retail_website_price"
                                    onChange={(e) => handleInputChange(e.target.name, e.target.value)}

                                    placeholder="Our Price"
                                    type="number"
                                    inputMode="numeric"
                                    min="0"
                                    step="any"
                                  />
                                  <p>Inventory :</p>
                                  <p>COGS Price :</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="product-type">
                            <div className="new-retail">
                              <h5>New-2nd Hand</h5>

                              <input
                                type="checkbox"
                                id="checkboxx"
                                value="2"
                                name="checkbox"
                                onClick={handleProductType}
                              />
                            </div>
                            <div className="prices">
                              <div className="market-price">
                                <h5 className=" mb-3">Market Price</h5>
                                <div>
                                  <FormControl
                                    name="new_second_hand_market_price"
                                    onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                                    type="number"
                                    inputMode="numeric"
                                    min="0"
                                    step="any"
                                    placeholder=""
                                  />
                                  <p>Date : {newProduct?.market_price_second_update_date?.trim() !== "" ? newProduct?.market_price_second_update_date : ""} </p>
                                </div>
                              </div>
                              <div className="Retail-price">
                                <h5 className=" mb-3">House Ask</h5>
                                <div>
                                  <FormControl
                                    name="new_second_hand_house_ask"
                                    placeholder=""
                                    type="number"
                                    inputMode="numeric"
                                    min="0"
                                    step="any"
                                    onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="product-type">
                            <div className="new-retail">
                              <h5>Used</h5>

                              <input
                                type="checkbox"
                                id="checkboxx"
                                name="checkbox"
                                value="3"
                                onClick={handleProductType}
                              />
                            </div>
                            <div className="prices">
                              <div className="market-price">
                                <h5 className=" mb-3">Market Price</h5>
                                <div>
                                  <FormControl
                                    name="used_market_price"
                                    onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                                    placeholder=""
                                    type="number"
                                    inputMode="numeric"
                                    min="0"
                                    step="any"
                                  />
                                  <p>Date: {newProduct?.market_price_used_update_date?.trim() !== "" ? newProduct?.market_price_used_update_date : ""} </p>
                                </div>
                              </div>
                              <div className="Retail-price">
                                <h5 className=" mb-3">House Ask</h5>
                                <div>
                                  <FormControl
                                    name="used_house_ask"
                                    type="number"
                                    inputMode="numeric"
                                    min="0"
                                    step="any"
                                    onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                                    placeholder=""
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="descrip mt-3 fs-4 fw-bold">
                        <h4 className="fs-6 fw-bold">Description</h4>
                        <div className="desc-main">
                          <CKEditor
                            editor={ClassicEditor}
                            data={newProduct.description}
                            config={{
                              allowedContent: true,
                              toolbar: {
                                items: [
                                  "heading",
                                  "|",
                                  "bold",
                                  "italic",
                                  "Underline",
                                  "Superscript",
                                  "Subscript",
                                  "Strikethrough",
                                  "fontSize",
                                  "fontColor",
                                  "fontBackgroundColor",
                                  "bulletedList",
                                  "numberedList",
                                  "|",
                                  "indent",
                                  "outdent",
                                  "|",
                                  "blockQuote",
                                  "insertTable",
                                  "|",
                                  "undo",
                                  "redo",
                                  "mediaEmbed",
                                  "imageUpload",
                                  "link",
                                  "fontFamily",
                                  "alignment",
                                ],
                              },
                              mediaEmbed: {
                                previewsInData: true,
                              },
                              image: {
                                toolbar: [
                                  "imageTextAlternative",
                                  "|",
                                  "imageStyle:full",
                                  "imageStyle:side",
                                ],
                                styles: ["alignLeft", "alignCenter", "alignRight"],
                              },
                              fontFamily: {
                                options: ["Helvetica", "Open Sans"],
                              },
                            }}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setNewProduct((prev) => ({
                                ...prev,
                                description: data
                              }))
                            }}
                          />
                        </div>
                      </div>

                      <div className="descrip mt-3 fs-4 fw-bold">
                        <h4 className="fs-6 fw-bold">Key specification</h4>
                        <div className="desc-main">
                          <CKEditor
                            editor={ClassicEditor}
                            data={newProduct.key_specifications}
                            config={{
                              allowedContent: true,
                              toolbar: {
                                items: [
                                  "heading",
                                  "|",
                                  "bold",
                                  "italic",
                                  "Underline",
                                  "Superscript",
                                  "Subscript",
                                  "Strikethrough",
                                  "fontSize",
                                  "fontColor",
                                  "fontBackgroundColor",
                                  "bulletedList",
                                  "numberedList",
                                  "|",
                                  "indent",
                                  "outdent",
                                  "|",
                                  "blockQuote",
                                  "insertTable",
                                  "|",
                                  "undo",
                                  "redo",
                                  "mediaEmbed",
                                  "imageUpload",
                                  "link",
                                  "fontFamily",
                                  "alignment",
                                ],
                              },
                              mediaEmbed: {
                                previewsInData: true,
                              },
                              image: {
                                toolbar: [
                                  "imageTextAlternative",
                                  "|",
                                  "imageStyle:full",
                                  "imageStyle:side",
                                ],
                                styles: ["alignLeft", "alignCenter", "alignRight"],
                              },
                              fontFamily: {
                                options: ["Helvetica", "Open Sans"],
                              },
                            }}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setNewProduct((prev) => ({
                                ...prev,
                                key_specifications: data
                              }))
                            }}
                          />
                        </div>
                      </div>

                      <div className="descrip mb-4">
                        <Form>
                          <FormLabel className="fw-bold fs-6 mt-3">SEO Title</FormLabel>
                          <FormControl
                            className=""
                            name="seoTitle"
                            onChange={(e) => handleInputChange("seoTitle", e.target.value)}
                            placeholder=""
                          />
                        </Form>
                      </div>
                      <div className="descr">
                        <Form>
                          <FormLabel className="fw-bold fs-6">
                            SEO Meta Description
                          </FormLabel>
                          <FormControl
                            name="metaDescription"
                            onChange={(e) => handleInputChange("metaDescription", e.target.value)}
                            placeholder=""
                          />
                        </Form>
                      </div>

                      <div className="text-center my-5">
                        <Button
                          className="text-white px-5 border-0 py-2 bg-success mx-1"
                          style={{
                            ...(loader.saveButtonLoading && {
                              opacity: 0.5,
                              pointerEvents: "none", 
                            }),
                          }}
                          variant="contained"
                          type="submit"
                          disabled={loader.saveButtonLoading}
                        >
                          {loader.saveButtonLoading ? "Saving..." : "Save"}

                        </Button>
                        <Button
                          style={{
                            ...(loader.saveButtonLoading && {
                              opacity: 0.5,
                              pointerEvents: "none",
                            }),
                          }}
                          variant="contained"
                          className="text-white px-5 border-0 py-2 bg-success"
                          onClick={handleemptyProduct}
                          disabled={loader.saveButtonLoading}
                        >
                          Cancel
                        </Button>{" "}
                      </div>

                    </Form>
                  </div>
                </Col>
              </Row>
            </div>
          )
      }
    </>
  );
};

export default NewProduct;
